import { UpToTop } from "@carbon/icons-react";
import { animateScroll } from "react-scroll";

const scrollToTop = () => animateScroll.scrollToTop();

const BackToTop = () => (
  <div className="back-to-top__sticky">
    <button type="button" onClick={scrollToTop}>
      <UpToTop />
    </button>
  </div>
);

export default BackToTop;
